import React, { useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import { useTable, useSortBy, usePagination } from "react-table";
import Pagination from "../Pagination";

const GeoLocTable = ({ groupedGeoData }) => {
  const columns = useMemo(
    () => [
      {
        Header: "Ville",
        accessor: "city",
      },
      {
        Header: "Date",
        accessor: "date_start",
      },
      {
        Header: "Impression",
        accessor: "impressions",
        getCellProps: () => ({
          className: "text-uppercase  font-weight-bolder opacity-7 text-end",
        }),
      },
      {
        Header: "Clicks",
        accessor: "clicks",
        getCellProps: () => ({
          className: "text-uppercase  font-weight-bolder opacity-7 text-end",
        }),
      },
      {
        Header: "Cpc",
        accessor: "averageCpc",
        getCellProps: () => ({
          className: "text-uppercase  font-weight-bolder opacity-7 text-end",
        }),
        Cell: ({ value }) => `${Number(parseFloat(value).toFixed(2))} €`,
        sortType: (rowA, rowB, columnName, desc) => {
          let a = parseFloat(rowA.original.averageCpc);
          let b = parseFloat(rowB.original.averageCpc);
          return a > b ? 1 : -1;
        },
      },
      {
        Header: "Dépenses",
        accessor: "totalCost",
        getCellProps: () => ({
          className: "text-uppercase  font-weight-bolder opacity-7 text-end",
        }),
        Cell: ({ value }) => `${Number(parseFloat(value).toFixed(2))} €`,
        sortType: (rowA, rowB, columnName, desc) => {
          let a = parseFloat(rowA.original.totalCost);
          let b = parseFloat(rowB.original.totalCost);
          return a > b ? 1 : -1;
        },
      },
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: groupedGeoData,
      initialState: { pageIndex: 0 },
    },
    useSortBy,
    usePagination
  );

  return (
    <>
      <Row>
        <Col md={12}>
          {" "}
          <div
            className="card medium-card mb-4 pb-2 purple-border"
            aria="gads"
            area-number="7"
            id="gads-area7"
            data-width="550"
          >
            <div className="card-header">
              <h1 className="text-black">Performance par ville</h1>
              <p className="text-2xl broun-text mb-0">
                Cliquez sur le titre de la colonne pour trier les données
              </p>
            </div>
            <div className=" card-body bg-white py-0">
              <Row className="mb-3">
                <Col md={12}>
                  <table
                    {...getTableProps()}
                    className="table align-items-center mb-0 text-2xl"
                  >
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                            {column.render("Header")}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? " 🔽"
                                  : " 🔼"
                                : ""}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}

                    <tbody {...getTableBodyProps()}>
                      {page.map((row, i) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <Pagination
                    gotoPage={gotoPage}
                    length={groupedGeoData.length}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default GeoLocTable;
